'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useMemo, useEffect, useRef, useCallback, useState } from 'react';
import { useInstantSearch, useSearchBox, Configure } from 'react-instantsearch';
import { useIsPopNavigation } from 'commons/navState';
import { NUMBER_OF_PRODUCTS_TO_SHOW } from 'commons/constants';
import useAdvancedSearchContext from '../../hooks/useAdvancedSearchContext';
import useFilterTransitionState from '../../hooks/useFilterTransitionState';
import AdvancedSearchProductsGrid from '../AdvancedSearchProductsGrid';
import AdvancedSearchLoadMoreButtons from '../AdvancedSearchProductsGrid/AdvancedSearchLoadMoreButtons';
import InitialProductsGrid from './InitialProductsGrid';
import ProductsGridSkeleton from './ProductsGridSkeleton';
import useHitsAccumulation from './hooks/useHitsAccumulation';
import useDisplayProducts from './hooks/useDisplayProducts';
import useScrollPersistence from './hooks/useScrollPersistence';
const ALGOLIA_MAX_HITS_PER_PAGE = 1000;
const AdvancedSearchProductHits = t0 => {
  const $ = _c(111);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    onProductsChange,
    initialProducts,
    seedServerData,
    eagerFirstPageImages: t2,
    enableShowAllButton: t3
  } = t1;
  const eagerFirstPageImages = t2 === undefined ? false : t2;
  const enableShowAllButton = t3 === undefined ? false : t3;
  const {
    items,
    isLastPage,
    showMore
  } = useHitsAccumulation();
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      skipSuspense: true
    };
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const {
    results,
    status,
    setIndexUiState,
    indexUiState,
    refresh
  } = useInstantSearch(t4);
  const {
    query: searchBoxQuery
  } = useSearchBox();
  const {
    currentProductIndex,
    isReadyToShipActive,
    minWidth,
    maxWidth,
    activeTypeFilter,
    pagesUrlParam,
    updateUrlParamImmediate,
    selectedFacets
  } = useAdvancedSearchContext();
  const isPopNavigation = useIsPopNavigation();
  let t5;
  if ($[3] !== isPopNavigation) {
    t5 = isPopNavigation();
    $[3] = isPopNavigation;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const isPopRef = useRef(t5);
  const scrollRestoredRef = useRef(false);
  const targetPagesRef = useRef(pagesUrlParam);
  const isLoadingAllRef = useRef(false);
  const showAllTargetCountRef = useRef(null);
  const [isLoadingAll, setIsLoadingAll] = useState(false);
  const [showAllHitsPerPage, setShowAllHitsPerPage] = useState(null);
  let t6;
  let t7;
  if ($[5] !== activeTypeFilter || $[6] !== setIndexUiState) {
    t6 = () => {
      setIndexUiState(prev => {
        const currentType = prev?.refinementList?.type?.[0] ?? null;
        if (currentType === activeTypeFilter) {
          return prev;
        }
        const newRefinementList = {
          ...(prev.refinementList || {})
        };
        if (activeTypeFilter) {
          newRefinementList.type = [activeTypeFilter];
        } else {
          delete newRefinementList.type;
        }
        return {
          ...prev,
          refinementList: newRefinementList
        };
      });
    };
    t7 = [activeTypeFilter, setIndexUiState];
    $[5] = activeTypeFilter;
    $[6] = setIndexUiState;
    $[7] = t6;
    $[8] = t7;
  } else {
    t6 = $[7];
    t7 = $[8];
  }
  useEffect(t6, t7);
  const currentPageCount = Math.ceil((items?.length || 0) / NUMBER_OF_PRODUCTS_TO_SHOW);
  let t8;
  if ($[9] !== currentPageCount || $[10] !== isLastPage || $[11] !== items?.length || $[12] !== showAllHitsPerPage || $[13] !== showMore || $[14] !== status) {
    t8 = () => {
      if (status !== "idle" || !items?.length || isLastPage) {
        return;
      }
      if (isLoadingAllRef.current || showAllHitsPerPage != null) {
        return;
      }
      if (currentPageCount - 1 < targetPagesRef.current) {
        showMore();
      }
    };
    $[9] = currentPageCount;
    $[10] = isLastPage;
    $[11] = items?.length;
    $[12] = showAllHitsPerPage;
    $[13] = showMore;
    $[14] = status;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const t9 = items?.length;
  let t10;
  if ($[16] !== currentPageCount || $[17] !== isLastPage || $[18] !== showAllHitsPerPage || $[19] !== showMore || $[20] !== status || $[21] !== t9) {
    t10 = [currentPageCount, status, t9, isLastPage, showMore, showAllHitsPerPage];
    $[16] = currentPageCount;
    $[17] = isLastPage;
    $[18] = showAllHitsPerPage;
    $[19] = showMore;
    $[20] = status;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  useEffect(t8, t10);
  indexUiState?.refinementList;
  let t11;
  if ($[23] !== currentProductIndex || $[24] !== indexUiState?.refinementList || $[25] !== isReadyToShipActive || $[26] !== maxWidth || $[27] !== minWidth || $[28] !== selectedFacets) {
    t11 = JSON.stringify({
      currentProductIndex,
      refinementList: indexUiState?.refinementList || {},
      isReadyToShipActive,
      minWidth,
      maxWidth,
      selectedFacets: selectedFacets ? Object.fromEntries(Object.entries(selectedFacets).map(_temp)) : undefined
    });
    $[23] = currentProductIndex;
    $[24] = indexUiState?.refinementList;
    $[25] = isReadyToShipActive;
    $[26] = maxWidth;
    $[27] = minWidth;
    $[28] = selectedFacets;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  const filterStateKey = t11;
  let t12;
  if ($[30] !== activeTypeFilter || $[31] !== filterStateKey || $[32] !== items || $[33] !== pagesUrlParam || $[34] !== setIndexUiState || $[35] !== status || $[36] !== updateUrlParamImmediate) {
    t12 = {
      filterStateKey,
      setIndexUiState,
      items,
      status,
      activeTypeFilter,
      pagesUrlParam,
      updateUrlParamImmediate,
      isPopRef,
      scrollRestoredRef,
      targetPagesRef
    };
    $[30] = activeTypeFilter;
    $[31] = filterStateKey;
    $[32] = items;
    $[33] = pagesUrlParam;
    $[34] = setIndexUiState;
    $[35] = status;
    $[36] = updateUrlParamImmediate;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  const {
    isFilterTransitioning,
    hasSearchCompleted,
    showNoResults
  } = useFilterTransitionState(t12);
  let t13;
  if ($[38] !== seedServerData) {
    t13 = seedServerData?.products?.length ? {
      products: seedServerData.products,
      upholsteryOptions: seedServerData.upholsteryOptions
    } : undefined;
    $[38] = seedServerData;
    $[39] = t13;
  } else {
    t13 = $[39];
  }
  const seed = t13;
  let t14;
  if ($[40] !== items || $[41] !== results || $[42] !== searchBoxQuery || $[43] !== seed) {
    t14 = {
      items,
      searchBoxQuery,
      results,
      seed
    };
    $[40] = items;
    $[41] = results;
    $[42] = searchBoxQuery;
    $[43] = seed;
    $[44] = t14;
  } else {
    t14 = $[44];
  }
  const {
    displayProducts,
    loading,
    productIds,
    productIdsRaw
  } = useDisplayProducts(t14);
  const t15 = items?.length;
  let t16;
  if ($[45] !== currentPageCount || $[46] !== loading || $[47] !== productIds.length || $[48] !== productIdsRaw.length || $[49] !== status || $[50] !== t15) {
    t16 = {
      isPopRef,
      scrollRestoredRef,
      targetPagesRef,
      status,
      currentPageCount,
      itemsLength: t15,
      loading,
      productIdsLength: productIds.length,
      productIdsRawLength: productIdsRaw.length
    };
    $[45] = currentPageCount;
    $[46] = loading;
    $[47] = productIds.length;
    $[48] = productIdsRaw.length;
    $[49] = status;
    $[50] = t15;
    $[51] = t16;
  } else {
    t16 = $[51];
  }
  useScrollPersistence(t16);
  let t17;
  let t18;
  if ($[52] !== displayProducts || $[53] !== onProductsChange) {
    t17 = () => {
      if (onProductsChange && displayProducts?.length > 0) {
        onProductsChange(displayProducts);
      }
    };
    t18 = [displayProducts, onProductsChange];
    $[52] = displayProducts;
    $[53] = onProductsChange;
    $[54] = t17;
    $[55] = t18;
  } else {
    t17 = $[54];
    t18 = $[55];
  }
  useEffect(t17, t18);
  let t19;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = () => {
      isLoadingAllRef.current = false;
      showAllTargetCountRef.current = null;
      setIsLoadingAll(false);
      setShowAllHitsPerPage(null);
    };
    $[56] = t19;
  } else {
    t19 = $[56];
  }
  let t20;
  if ($[57] !== filterStateKey) {
    t20 = [filterStateKey];
    $[57] = filterStateKey;
    $[58] = t20;
  } else {
    t20 = $[58];
  }
  useEffect(t19, t20);
  let t21;
  if ($[59] !== pagesUrlParam || $[60] !== showMore || $[61] !== updateUrlParamImmediate) {
    t21 = () => {
      const nextPages = pagesUrlParam + 1;
      showMore();
      targetPagesRef.current = nextPages;
      updateUrlParamImmediate?.({
        pages: nextPages
      });
    };
    $[59] = pagesUrlParam;
    $[60] = showMore;
    $[61] = updateUrlParamImmediate;
    $[62] = t21;
  } else {
    t21 = $[62];
  }
  const handleShowMore = t21;
  let t22;
  if ($[63] !== items?.length || $[64] !== refresh || $[65] !== results?.nbHits || $[66] !== setIndexUiState) {
    t22 = () => {
      const totalHits = results?.nbHits ?? 0;
      if (!totalHits || totalHits <= (items?.length ?? 0)) {
        return;
      }
      isLoadingAllRef.current = true;
      setIsLoadingAll(true);
      const hitsPerPage = Math.min(totalHits, ALGOLIA_MAX_HITS_PER_PAGE);
      showAllTargetCountRef.current = hitsPerPage;
      setShowAllHitsPerPage(hitsPerPage);
      targetPagesRef.current = 0;
      setIndexUiState(_temp2);
      refresh();
    };
    $[63] = items?.length;
    $[64] = refresh;
    $[65] = results?.nbHits;
    $[66] = setIndexUiState;
    $[67] = t22;
  } else {
    t22 = $[67];
  }
  results?.nbHits;
  items?.length;
  const handleShowAll = t22;
  let t23;
  if ($[68] !== isLastPage || $[69] !== items?.length || $[70] !== loading || $[71] !== status || $[72] !== updateUrlParamImmediate) {
    t23 = () => {
      if (!isLoadingAllRef.current) {
        return;
      }
      if (status !== "idle" || loading) {
        return;
      }
      const requestedBatch = showAllTargetCountRef.current;
      const batchReceived = requestedBatch != null && (items?.length ?? 0) >= requestedBatch;
      const showAllComplete = isLastPage || batchReceived;
      if (!showAllComplete) {
        return;
      }
      isLoadingAllRef.current = false;
      showAllTargetCountRef.current = null;
      setIsLoadingAll(false);
      targetPagesRef.current = 0;
      updateUrlParamImmediate?.({
        pages: undefined
      });
    };
    $[68] = isLastPage;
    $[69] = items?.length;
    $[70] = loading;
    $[71] = status;
    $[72] = updateUrlParamImmediate;
    $[73] = t23;
  } else {
    t23 = $[73];
  }
  const t24 = items?.length;
  let t25;
  if ($[74] !== isLastPage || $[75] !== loading || $[76] !== status || $[77] !== t24 || $[78] !== updateUrlParamImmediate) {
    t25 = [isLastPage, status, loading, t24, updateUrlParamImmediate];
    $[74] = isLastPage;
    $[75] = loading;
    $[76] = status;
    $[77] = t24;
    $[78] = updateUrlParamImmediate;
    $[79] = t25;
  } else {
    t25 = $[79];
  }
  useEffect(t23, t25);
  const isRefreshing = status === "loading" || status === "stalled" || loading;
  const t26 = !isLastPage;
  let t27;
  if ($[80] !== enableShowAllButton || $[81] !== handleShowAll || $[82] !== handleShowMore || $[83] !== isLoadingAll || $[84] !== loading || $[85] !== t26) {
    t27 = {
      enableShowAllButton,
      onLoadMore: handleShowMore,
      onShowAll: handleShowAll,
      isLoading: loading,
      isLoadingAll,
      showLoadMore: t26
    };
    $[80] = enableShowAllButton;
    $[81] = handleShowAll;
    $[82] = handleShowMore;
    $[83] = isLoadingAll;
    $[84] = loading;
    $[85] = t26;
    $[86] = t27;
  } else {
    t27 = $[86];
  }
  const loadMoreButtonsProps = t27;
  const showInitialProducts = initialProducts?.length > 0 && !hasSearchCompleted;
  if (!items?.length) {
    const showSkeleton = status === "loading" || status === "stalled" || isFilterTransitioning || !hasSearchCompleted || !showNoResults;
    if (showSkeleton) {
      if (showInitialProducts) {
        let t28;
        if ($[87] !== initialProducts || $[88] !== loadMoreButtonsProps) {
          t28 = <InitialProductsGrid products={initialProducts} expectedCount={NUMBER_OF_PRODUCTS_TO_SHOW} loadMoreButtonsProps={loadMoreButtonsProps} />;
          $[87] = initialProducts;
          $[88] = loadMoreButtonsProps;
          $[89] = t28;
        } else {
          t28 = $[89];
        }
        return t28;
      }
      let t28;
      if ($[90] === Symbol.for("react.memo_cache_sentinel")) {
        t28 = <ProductsGridSkeleton count={NUMBER_OF_PRODUCTS_TO_SHOW} />;
        $[90] = t28;
      } else {
        t28 = $[90];
      }
      return t28;
    }
    let t28;
    if ($[91] === Symbol.for("react.memo_cache_sentinel")) {
      t28 = <div role="status" aria-live="polite" className="py-8 text-center">No results found.</div>;
      $[91] = t28;
    } else {
      t28 = $[91];
    }
    return t28;
  }
  if (!displayProducts?.length) {
    if (showInitialProducts) {
      let t28;
      if ($[92] !== initialProducts || $[93] !== items.length || $[94] !== loadMoreButtonsProps) {
        t28 = <InitialProductsGrid products={initialProducts} expectedCount={items.length} loadMoreButtonsProps={loadMoreButtonsProps} />;
        $[92] = initialProducts;
        $[93] = items.length;
        $[94] = loadMoreButtonsProps;
        $[95] = t28;
      } else {
        t28 = $[95];
      }
      return t28;
    }
    const stillWaitingForEnrichment = loading || status === "loading" || status === "stalled" || isFilterTransitioning;
    if (stillWaitingForEnrichment) {
      let t28;
      if ($[96] !== items.length) {
        t28 = <ProductsGridSkeleton count={items.length} />;
        $[96] = items.length;
        $[97] = t28;
      } else {
        t28 = $[97];
      }
      return t28;
    }
    let t28;
    if ($[98] === Symbol.for("react.memo_cache_sentinel")) {
      t28 = <div role="status" aria-live="polite" className="py-8 text-center">No results found.</div>;
      $[98] = t28;
    } else {
      t28 = $[98];
    }
    return t28;
  }
  const t28 = isRefreshing ? "animate-pulse" : "";
  let t29;
  if ($[99] !== showAllHitsPerPage) {
    t29 = showAllHitsPerPage != null && <Configure hitsPerPage={showAllHitsPerPage} />;
    $[99] = showAllHitsPerPage;
    $[100] = t29;
  } else {
    t29 = $[100];
  }
  const t30 = eagerFirstPageImages ? NUMBER_OF_PRODUCTS_TO_SHOW : 0;
  let t31;
  if ($[101] !== displayProducts || $[102] !== t30) {
    t31 = <AdvancedSearchProductsGrid products={displayProducts} eagerImageCount={t30} />;
    $[101] = displayProducts;
    $[102] = t30;
    $[103] = t31;
  } else {
    t31 = $[103];
  }
  let t32;
  if ($[104] !== loadMoreButtonsProps) {
    t32 = <AdvancedSearchLoadMoreButtons {...loadMoreButtonsProps} />;
    $[104] = loadMoreButtonsProps;
    $[105] = t32;
  } else {
    t32 = $[105];
  }
  let t33;
  if ($[106] !== t28 || $[107] !== t29 || $[108] !== t31 || $[109] !== t32) {
    t33 = <div className={t28}>{t29}{t31}{t32}</div>;
    $[106] = t28;
    $[107] = t29;
    $[108] = t31;
    $[109] = t32;
    $[110] = t33;
  } else {
    t33 = $[110];
  }
  return t33;
};
export default AdvancedSearchProductHits;
function _temp(t0) {
  const [attr, values] = t0;
  return [attr, [...values].sort()];
}
function _temp2(prev_0) {
  return {
    ...prev_0,
    page: 0
  };
}